import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useAuthProvider } from "../../customHooks/authContext";
import { usePut } from "../../customHooks/usePut";
import { FaSave, FaTimesCircle } from "react-icons/fa";
import ConfirmModal from "../ConfirmModal";

function MemberEdit({ member, onClose, refetch, schoolId: externalSchoolId }) {
  const { token, school } = useAuthProvider();
  const resolvedSchoolId = externalSchoolId || school?.id;
  const [memberData, setMemberData] = useState({
    name: "",
    surname: "",
    birthdate: "",
    status: true,
  });
  const { executePut, error, loading } = usePut();

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  useEffect(() => {
    if (member) {
      setMemberData({
        name: member.name,
        surname: member.surname,
        birthdate: member.birthdate,
        status: member.status,
      });
    }
  }, [member]);

  const capitalizeFirstLetter = (string) => {
    return string
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const handleOpenConfirmModal = (e) => {
    e.preventDefault();
    setIsConfirmModalOpen(true);
  };

  const handleConfirmSave = async () => {
    setIsConfirmModalOpen(false);

    try {
      const updatedMember = {
        ...memberData,
        status: memberData.status,
      };

      const response = await executePut(
        `https://ectech-software.com.ar/api/academy/schools/${externalSchoolId}/members/${member.id}`,
        updatedMember,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response) {
        refetch();
        onClose();
      }
    } catch (err) {
      console.error("Error al actualizar el miembro:", err);
      alert("Error al actualizar el miembro. Verifica los datos e inténtalo nuevamente.");
    }
  };

  if (loading) return <p className="text-center">Cargando...</p>;
  if (error) return <p className="text-danger text-center">Error: {error.message}</p>;

  return (
    <div className="container mt-4">
      <div className="card shadow-lg p-4 w-100" style={{ maxWidth: "600px", margin: "auto" }}>
        <div className="card-header bg-primary text-white text-center">
          <h5 className="mb-0">Editar Miembro</h5>
        </div>
        <div className="card-body">
          <form onSubmit={handleOpenConfirmModal}>
            {[
              { label: "Nombre", name: "name", type: "text" },
              { label: "Apellido", name: "surname", type: "text" },
              { label: "Fecha de Nacimiento", name: "birthdate", type: "date" },
            ].map(({ label, name, type }) => (
              <div className="form-floating mb-3" key={name}>
                <input
                  type={type}
                  id={name}
                  name={name}
                  value={memberData[name]}
                  onChange={(e) => setMemberData({ ...memberData, [name]: capitalizeFirstLetter(e.target.value) })}
                  className="form-control"
                  required
                />
                <label htmlFor={name}>{label}</label>
              </div>
            ))}

            <div className="mb-3 form-check">
              <input
                type="checkbox"
                id="status"
                name="status"
                className="form-check-input"
                checked={memberData.status}
                onChange={(e) => setMemberData({ ...memberData, status: e.target.checked })}
              />
              <label htmlFor="status" className="form-check-label">Activo</label>
            </div>

            <div className="d-flex gap-2">
              <button type="submit" className="btn btn-success w-50">
                Guardar Cambios <FaSave className="ms-2" />
              </button>
              <button type="button" className="btn btn-outline-secondary w-50" onClick={onClose}>
                Cancelar <FaTimesCircle className="ms-2" />
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* ConfirmModal para confirmar la acción */}
      <ConfirmModal
        isOpen={isConfirmModalOpen}
        onClose={() => setIsConfirmModalOpen(false)}
        onConfirm={handleConfirmSave}
        message="¿Estás seguro de que deseas guardar los cambios?"
      />
    </div>
  );
}

export default MemberEdit;
